



















import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class Mconfirm extends Vue {
  @Prop({ type: String, default: '' })
  title!: string

  @Prop({ type: String, default: '' })
  time!: string

  @Prop({ type: String, default: '' })
  content!: string

  @Prop({ type: String, default: '取消' })
  confirmButtonText!: string

  @Prop({ type: String, default: '确认' })
  cancelButtonText!: string

  theConfirm = false

  resolve: any
  reject: any
  promise: any

  confirm() {
    this.theConfirm = false
    this.resolve('confirm')
    this.remove()
  }

  cancel() {
    this.theConfirm = false
    this.reject('cancel')
    this.remove()
  }

  showMsgBox() {
    this.theConfirm = true
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
    return this.promise
  }

  remove() {
    setTimeout(() => {
      this.destroy()
    }, 100)
  }

  destroy() {
    this.$destroy()
    document.body.removeChild(this.$el)
  }
}
